import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "creating-an-event-integration-project"
    }}>{`Creating an Event Integration Project`}</h1>
    <p>{`By using Adobe I/O Events, Cloud Manager can send external applications notifications when key events occur. This allows customers to connect existing and new external applications which respond to events emitted by Cloud Manager CI/CD pipelines.`}</p>
    <p>{`To work with the Cloud Manager Events on the Adobe Developer Console, you need to either the System Administrator role or be an assigned API Developer for your organization. Click `}<a parentName="p" {...{
        "href": "http://www.adobe.com/go/aac_api_prod_learn"
      }}>{`here`}</a>{` to learn more about the API Developer role.`}</p>
    <p>{`Adobe I/O Events emitted by Cloud Manager are sent to `}<strong parentName="p">{`webhooks`}</strong>{` hosted either in on-premise infrastructure, specialized webhook hosting providers, `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/runtime/docs/"
      }}>{`Adobe I/O Runtime`}</a>{`, or even your AEM instances managed by Adobe. Alternatively, the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/events/docs/guides/api/journaling_api/"
      }}>{`Adobe I/O Journaling API`}</a>{` may be used, especially in cases where network security rules prohibit a webhook from being accessible from the public internet.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/events/docs/guides/"
      }}>{`Getting Started with Adobe I/O Events`}</a>{` guide provides general documentation on how to set up a webhook.`}</p>
    <p>{`Once your webhook is up and running, to create an Event Integration:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Navigate to the following URL: `}<a parentName="p" {...{
            "href": "https://developer.adobe.com/console"
          }}>{`https://developer.adobe.com/console`}</a>{`. This can also be reached by clicking the Console button at the top of this page.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click the `}<inlineCode parentName="p">{`Create new project`}</inlineCode>{` button or select an existing project.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`(Optional) Click the `}<inlineCode parentName="p">{`Edit project`}</inlineCode>{` button and give your project a title and description.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click the `}<inlineCode parentName="p">{`Add to Project`}</inlineCode>{` button and select `}<inlineCode parentName="p">{`Event`}</inlineCode>{` from the drop-down menu.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under the Experience Cloud section select `}<inlineCode parentName="p">{`Cloud Manager`}</inlineCode>{` and then click `}<inlineCode parentName="p">{`Next`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select the events you want to receive on the webhook.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Choose `}<inlineCode parentName="p">{`OAuth Server-to-Server`}</inlineCode>{` authentication.
Note that authentication using `}<strong parentName="p">{`Generate or Upload a key pair`}</strong>{` is deprecated.`}</p>
      </li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "28.125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/5530d/creating-event-integration.webp 320w", "/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/0c8fb/creating-event-integration.webp 640w", "/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/94b1e/creating-event-integration.webp 1280w", "/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/0b34d/creating-event-integration.webp 1920w", "/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/82f9f/creating-event-integration.webp 2404w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/dd4a7/creating-event-integration.png 320w", "/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/0f09e/creating-event-integration.png 640w", "/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/bbbf7/creating-event-integration.png 1280w", "/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/ac7a9/creating-event-integration.png 1920w", "/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/bef4b/creating-event-integration.png 2404w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/experience-cloud/cloud-manager/static/07bd4b8a935c702308e5618e039c6ad4/bbbf7/creating-event-integration.png",
            "alt": "Choosing type of authentication",
            "title": "Choosing type of authentication",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">
        <p parentName="li">{`Fill out the name and description.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Provide the webhook URL or, if Adobe I/O Runtime is available, select the Runtime action.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Save configured events`}</inlineCode>{`.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      